class RecessVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.form = document.querySelector(`#${this.dataset.productFormId}`);

    // this.swymWishlistButtonEl = this.closest('.product').querySelector('.swym-add-to-wishlist-view-product');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // this.updateSWYMWishlistButton();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateSWYMWishlistButton() {
    if (document.querySelector(".collection__products-grid")) {
      this.swymWishlistButtonEl.setAttribute('data-variant-id', this.currentVariant.id);
      _swat.initializeActionButtons(".collection__products-grid");
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #${this.dataset.productFormId}`);
    productForms.forEach((productForm) => {
      const input = productForm.elements["id"];
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);


        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);


        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});

        // update Variant metafield description
        const variantDescriptionDestination = document.getElementById('variant-description-js-contents');
        const variantDescriptionSource = html.getElementById('variant-description-js-contents');
        if (variantDescriptionSource && variantDescriptionDestination) {
          variantDescriptionDestination.innerHTML = variantDescriptionSource.innerHTML;
        }

      });
  }


  async renderProductInfoOld() {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`;
    const response = await fetch(url);
    const responseText = await ((response) => response.text())(response);
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const destination = document.getElementById(`price-${this.dataset.productFormId}`);
    const source = html.getElementById(`price-${this.dataset.productFormId}`);
    if (source && destination) destination.innerHTML = source.innerHTML;

    const price = document.getElementById(`price-${this.dataset.productFormId}`);

    if (price) price.classList.remove('visibility-hidden');
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

    // this.updateMedia({ html });
    // this.updateBadges({ html });

    // update Variant metafield description
    const variantDescriptionDestination = document.getElementById('variant-description-js-contents');
    const variantDescriptionSource = html.getElementById('variant-description-js-contents');
    if (variantDescriptionSource && variantDescriptionDestination) {
      variantDescriptionDestination.innerHTML = variantDescriptionSource.innerHTML;
    }
  }


  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = this.form;

    if (!productForm) return;
    const addButton = productForm.elements["add"];
    const addButtonText = addButton.querySelector('span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = this.form;
    const addButton = productForm.elements["add"];
    const addButtonText = button.querySelector('span');
    const price = document.getElementById(`price-${this.dataset.productFormId}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.currentVariant.title, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateBadges({ html }) {
    // Badge
    let selector = `#badge-${this.dataset.productFormId}`;

    let destination = document.querySelector(selector);
    let source = html.querySelector(selector);

    // if (destination && source && destination.innerHTML != source.innerHTML) {
    //   destination.innerHTML = source.innerHTML;
    // }

    if (destination && source) {
      destination.innerHTML = source.innerHTML;
    }

  }
}

customElements.define('recess-variant-selects', RecessVariantSelects);

class RecessVariantRadios extends RecessVariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    fieldsets.forEach(fieldsetEl => {
      const { value } = Array.from(fieldsetEl.querySelectorAll('input')).find((radio) => radio.checked);
      fieldsetEl.querySelector('.option__selected-option-value').innerText = value;
    });
  }
}

customElements.define('recess-variant-radios', RecessVariantRadios);

class RecessSliderComponent extends SliderComponent {
  constructor() {
    super();

    this.slider = this.querySelector('.slider');
    this.sliderItems = this.querySelectorAll('.slider__slide');
    this.enabaleSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.sliderControls = this.querySelector('.slider-controls');

    if (!this.slider) return;

    this.initPages();

    const resizeObserver = new ResizeObserver((entries) => this.initPages);

    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.sliderControls) this.sliderControls.addEventListener('click', this.handleControlsClick.bind(this));

  }

  initPages() {
    this.classList.add('active');
    this.sliderItemsToShow = [...this.sliderItems].filter((el) => el.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];

    if (this.sliderItemsToShow.length === 0) return;

    this.sliderPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.sliderPerPage + 1;
    this.update();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currenElement: this.sliderItemsToShow[this.currentPage - 1],
        }
      }));
    }

    if (this.enabaleSliderLooping) return;
  }

  handleControlsClick({ target }) {
    if (target.closest('button')?.classList.contains('js-button-left')) {
      this.slider.scrollLeft -= this.clientWidth
    } else if (target.closest('button')?.classList.contains('js-button-right')) {
      this.slider.scrollLeft += this.clientWidth
    }
  }
}

customElements.define('recess-slider-component', RecessSliderComponent);

class RecessProductHeroSliderComponent extends SliderComponent {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enabaleSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');


    this.sliderControls = this.querySelector('.slider-controls');

    if (!this.slider || !this.nextButton) return;

    this.initPages();

    const resizeObserver = new ResizeObserver((entries) => this.initPages);

    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    // if (this.sliderControls) this.sliderControls.addEventListener('click', this.handleControlsClick.bind(this));

  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('recess-product-hero-slider-component', RecessProductHeroSliderComponent);

class MinicartRecommendations extends HTMLElement {
  constructor() {
    super();

    this.limit = this.dataset.limit;
    this.productId = this.dataset.productId;
    this.url = this.dataset.productRecommendationsUrl;

    fetch(`${this.url}?product_id=${this.productId}&limit=${this.limit}&section_id=minicart-recommendations`)
      .then(response => response.text())
      .then((text) => {
        const html = document.createElement('div');

        html.innerHTML = text;

        const recommendations = html.querySelector('.shopify-section');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
  }
}

customElements.define('minicart-recommendations', MinicartRecommendations);

class GiftingModule extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.productForm = this.querySelector('product-form');
    this.textareaEl = this.querySelector('textarea');
    this.debounceOnChange = debounce((e) => this.handleChange(e), 300);

    this.addEventListener('change', this.debounceOnChange.bind(this));
  }

  handleChange({ target }) {
    switch (target.id) {
      case 'gift-note-textarea':
        this.saveGiftNote(target.value);
        break;

      case 'gift-note-input':
        if (target.checked) this.showTextarea()
        else {
          this.saveGiftNote('');
          this.hideTextarea();
        }

        break;

      case 'special-packaging':
        const { checked, dataset } = target;

        this.addRemoveSpecialPackaging(target);
        break;

      default:
        break;
    }
  }

  addRemoveSpecialPackaging({ checked, dataset }) {
    if (checked) {
      this.productForm?.form?.submit();
    } else {
      this.cart?.querySelector('cart-items')?.updateQuantity(dataset.index, 0);
    }
  }

  hideTextarea() {
    this.textareaEl.parentElement.classList.remove('active');
  }

  async saveGiftNote(note) {
    const body = JSON.stringify({
      attributes: {
        'gift-message': note,
      },
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      section_url: window.location.pathname
    });

    await fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } })
      .then((res) => res.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.cart.renderContents(parsedState);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }

  showTextarea() {
    this.textareaEl.parentElement.classList.add('active');
    this.textareaEl.focus();
  }
}

customElements.define('gifting-module', GiftingModule);



document.addEventListener('DOMContentLoaded', () => {


  const detailsContainer = document.querySelector('.product-details');
  const bubbles = detailsContainer ? [...detailsContainer.querySelectorAll('.bubble')] : [];

  detailsContainer?.addEventListener('click', event => {
    const { target } = event;

    if (!target.classList.contains('bubble-header')) return;

    detailsContainer?.querySelectorAll('.bubble').forEach((bubble) => {

      const bubbleHeader = bubble.querySelector('.bubble-header')
      const bubbleContainer = bubble.querySelector('.bubble-container')

      if (bubbleHeader === event.target) {
        bubble.classList.toggle('expanded')

        if (bubbleContainer.style.maxHeight) {
          bubbleContainer.style.maxHeight = null;
        } else {
          bubbleContainer.style.maxHeight = bubbleContainer.scrollHeight + "px";
        }

      } else {
        bubble.classList.remove('expanded');
        bubbleContainer.style.maxHeight = null;
      }
    });
  });
});
